import { render, staticRenderFns } from "./AuthLetter.vue?vue&type=template&id=622637d2&scoped=true"
import script from "./AuthLetter.vue?vue&type=script&lang=js"
export * from "./AuthLetter.vue?vue&type=script&lang=js"
import style0 from "./AuthLetter.vue?vue&type=style&index=0&id=622637d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622637d2",
  null
  
)

export default component.exports